import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { store } from 'redux/index';
import { setResourceParent } from 'redux/reducers';
import { getHomesHouseList, getHomesRPList } from 'redux/selectors';
import { UserList, SlideContainer } from 'components';

function RPListContainer({
	basePath = '/resource-parents',
	homesBasePath = '/homes',
	caseManager = false,
}) {
	const history = useHistory();
	const resourceParentList = useSelector(getHomesRPList);
	const houseList = useSelector(getHomesHouseList);
	const needsHousehold = houseList.length === 0;

	const houseListMap = resourceParentList?.map((val) => {
		return { ...val, name: `${val.firstname} ${val.lastname}` };
	});

	const onSelectRP = (e, { id }) => {
		const rp = resourceParentList.filter((parent) => parent.id === id);
		store.dispatch(setResourceParent(rp));
		history.push(`${basePath}/manage/${id}`);
	};

	const onAddRP = () => {
		history.push(
			needsHousehold ? `${homesBasePath}/manage` : `${basePath}/manage`
		);
	};

	return (
		<SlideContainer>
			<UserList
				list={houseListMap}
				label='Parents'
				pathParam='rpId'
				handleSelect={onSelectRP}
				addToggle={onAddRP}
				addLabel={needsHousehold ? 'Add a Household First' : 'Add a Parent'}
			/>
		</SlideContainer>
	);
}

export default RPListContainer;
